import React, {Component} from 'react';
import {areaHotspotsSettings} from './settings';
import {ShipContext} from './context/ShipContext';
import {GlobalContext} from "./context/GlobalContext";
import Hotspot from './Hotspot';
import {capitalizeFirstLetter} from '../../utils';

class HotspotCameraDependant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            twoDCoordinates: {
                x: -1000,
                y: 0
            }
        };
        this.hotspotSettings = areaHotspotsSettings[this.props.areaName];
        this.handleClick = this.handleClick.bind(this);
    }


    positionHotspot() {
        if (this.props.shipHasLoaded && typeof this.hotspotSettings !== 'undefined') {
            this.setState({
                twoDCoordinates: this.props.getTwoDCoordinatesFromThreeD(this.hotspotSettings.coordinates)
            });
        }
    }

    handleClick() {
        this.props.moveCameraToPosition(this.hotspotSettings.cameraCoordinates);
        this.props.setActiveAreaId(this.props.areaId);
        this.props.setCategoriesListVisibility(true);
    }

    render() {
        let hotspotStyles = {},
            hotspotClasses = 'hotspot js-hotspot';

        hotspotStyles.transform = `translate(${this.state.twoDCoordinates.x}px, ${this.state.twoDCoordinates.y}px)`;
        hotspotStyles.display = 'block';

        if (this.props.activeAreaId === this.props.areaId) {
            hotspotClasses += " hotspot--active";
        } else if (this.props.activeAreaId.length !== 0) {
            hotspotStyles.opacity = 0;
            hotspotStyles.visibility = 'hidden';
        }

        const
            shipType = capitalizeFirstLetter(this.props.ship),
            id = `${this.props.areaName}${shipType}`;

        return (
            <Hotspot
                hotspotClasses={hotspotClasses}
                id={id}
                style={hotspotStyles}
                onClick={this.handleClick}
                labelText={this.props.hotspotLabelText}
            />
        )
    }
}

export default React.forwardRef((props, ref) => (
    <GlobalContext.Consumer>
        {(globalContext) => (
            <ShipContext.Consumer>
                {(shipContext) => (
                    <HotspotCameraDependant
                        setActiveAreaId={shipContext.setActiveAreaId}
                        activeAreaId={shipContext.activeAreaId}
                        ship={shipContext.shipType}
                        setCategoriesListVisibility={globalContext.setCategoriesListVisibility}
                        ref={ref}
                        {...props}
                    />
                )}
            </ShipContext.Consumer>
        )}
    </GlobalContext.Consumer>
))